import React, { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import { EliminarPersona, getClientes } from "../../api/Clientes";
import PaginadorComponent from "../../components/PaginadorComponent";
import { Icon } from "@iconify/react/dist/iconify.js";
import LoaderComponent from "../../components/LoaderComponent";
import stylebtn from '../../styles/btn.module.scss';
import { Link } from "react-router-dom";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import AlertComponent from "../../components/AlertComponent";
import InputComponent from "../../components/InputComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import { EditarPersona, PostPersona } from "../../api/Empleado";
import { getTransporte, PostTransporte } from "../../api/transporte";
import { BuscarCliente } from "../../api/ApiVenta";

const TransportePage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [showEliminar, setShowEliminar] = useState(false);
    const [currentTransporte, setCurrentTransporte] = useState([]);
    const [currentPersona, setCurrentPersona] = useState([]);
    const [alert, setAlert] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [showEdit, setShowEdit] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [control, setcontrol] = useState(false);
    const [isverificado, setIsverificado] = useState(false);
    const [show, setShow] = useState(false);
    const [formDataPersona, setFormDataPersona] = useState({
        cedula: '',
        nombre: '',
        apellido: '',
        direccion: '',
        celular: '',
    });

    const itemsPerPage = 7;
    const pageCount = Math.ceil(data.length / itemsPerPage);
    const currentPageDatatransporte = data.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    //metodos para el popup de eliminar un cliente 
    const handleCloseEliminar = () => setShowEliminar(false);
    const handleShowEliminar = async (persona) => {
        setShowEliminar(true);
        setCurrentPersona(persona);
    }

    const handleClose = () => {
        setShowEdit(false);
        setShow(false);
        setIsverificado(false);
    };

    //metodo para mostrar el popup de editar
    const handleShowEditar = (item) => {
        setShow(true);
        setShowEdit(true);
        setIsverificado(true);
        setCurrentPersona(item);
        setFormDataPersona({
            cedula: item?.Persona?.cedula,
            nombre: item?.Persona?.nombre,
            apellido: item?.Persona?.apellido,
            direccion: item?.Persona?.direccion,
            celular: item?.Persona?.celular,
        });
    };

    // Manejar el cambio en el input
    const handleInputChangePersona = (event) => {
        const { name, value } = event.target;
        setFormDataPersona({
            ...formDataPersona,
            [name]: value,
        });
    };

    const handleShow = () => {
        setShow(true);
        setShowEdit(false);
        setFormDataPersona({
            cedula: "",
            nombre: "",
            apellido: "",
            direccion: "",
            celular: "",
        });
    };


    // Metodo para crear los transportes
    const crearTransporte = async (e) => {
        e.preventDefault();
        try {
            // verifico que todo los datos esten llenos

            if (
                formDataPersona.cedula === "" ||
                formDataPersona.nombre === "" ||
                formDataPersona.apellido === ""
            ) {
                setMensaje("Los campos que estan vacios son obligatorios *");
            } else {
                // si la perosna no exite en la base de datos
                if (!control || control == false) {
                    const resP = await PostPersona(formDataPersona);
                    setMensaje(resP.msg);
                    if (resP.success) {
                        setAlert(true);
                        await PostTransporte(
                            resP.data.idP,
                        );
                        handleClose();
                        mostrarTransporte();

                        setFormDataPersona({
                            cedula: "",
                            nombre: "",
                            apellido: "",
                            direccion: "",
                            celular: "",
                        });
                    }
                } else if (currentTransporte?.length === 0) {
                    await PostTransporte(
                        currentPersona?.idP,
                    );
                    handleClose();
                    mostrarTransporte();
                    setFormDataPersona({
                        cedula: "",
                        nombre: "",
                        apellido: "",
                        direccion: "",
                        celular: "",
                    });
                } else {
                    setMensaje("El empleado ya existe");
                }
            }
        } catch (error) {
            console.log(error);
        }

        setTimeout(() => {
            setAlert(false);
            setMensaje("");
        }, 5000);
    };

    const mostrarTransporte = async (filters = {}) => {
        setLoading(true);
        try {
            const res = await getTransporte(filters);
            setData(res?.data);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        mostrarTransporte();
    }, [])


    const eliminarTransporte = async () => {
        try {
            const res = await EliminarPersona(currentPersona?.Persona?.idP);
            if (res.success) {
                handleCloseEliminar();
                mostrarTransporte();
                setAlert(true);
                setMensaje(res.message);
            }
        } catch (error) {
            console.log(error);
        }

        setTimeout(() => {
            setMensaje('')
            setAlert(false)
        }, [5000]);
    }

    const editarTransporte = async (e) => {
        e.preventDefault();
        try {
            const resP = await EditarPersona(currentPersona?.Persona?.idP, formDataPersona);
            if (resP.success) {
                setAlert(true);
                setMensaje(resP.msg);
                mostrarTransporte();
                handleClose();
            }

        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            setAlert(false);
            setMensaje('');
        }, 3000);
    }


    const buscarTransporte = (e) => {
        e.preventDefault();
        const filters = {
            searchQuery: searchQuery,
        };

        mostrarTransporte(filters);
    }

    // metodo para consultar la cc
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            consultarCedula();
        }
    };

    const consultarCedula = async () => {
        try {
            setIsverificado(true)
            const res = await BuscarCliente(formDataPersona.cedula);
            if (res.success) {
                setFormDataPersona({
                    cedula: res?.data?.cedula,
                    nombre: res?.data?.nombre,
                    apellido: res?.data?.apellido,
                    direccion: res?.data?.direccion,
                    celular: res?.data?.celular,
                });

                setCurrentPersona(res?.data);
                setCurrentTransporte(res?.data?.Transportes);
            } else {
                setMensaje(res.msg);
                setFormDataPersona({
                    cedula: formDataPersona.cedula,
                    nombre: "",
                    apellido: "",
                    direccion: "",
                    celular: "",
                });
            }
            setcontrol(res.success);
        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            setMensaje("");
        }, 3000);
    };



    return (
        <Fragment>

            <div className='d-flex justify-content-center'>
                <AlertComponent styleGroup="bg-soccess color-white" mensaje={mensaje} activaalert={alert} />
            </div>
            <HeaderComponent>
                <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">TRANSPORTE</TitleH2Component>
                <button
                    type="button"
                    onClick={handleShow}
                    className={`${stylebtn.btn} ${stylebtn.primary} `}
                >
                    AGREGAR TRANSPORTE
                </button>
            </HeaderComponent>
            {loading ? (
                <LoaderComponent styleGroup="mt-5" />
            ) : (
                <div className="conatiner-global pt-3 mb-5">

                        <section>
                            <div className="container">
                                <form action="" onSubmit={buscarTransporte}>
                                    <div className="row gy-4 d-flex justify-content-end align-items-end">
                                        <div className="col-12 col-md-6 col-xl-3">
                                            <InputComponent
                                                placeholder="Ingresar documento o nombre"
                                                label="Buscar transporte"
                                                styleLabel="fw600 WorkSans"
                                                htmlFor="bloque"
                                                type="search"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-2">
                                            <button type="submit" className={`${stylebtn.btn} ${stylebtn.primary} `}>
                                                Buscar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>

                    <section>
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered tableGeneral">
                                <thead>
                                    <tr>
                                        <th scope="col " className="color-madera">
                                            #
                                        </th>
                                        <th scope="col " className="color-madera">
                                            CC
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Nombres
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Apellidos
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Celular
                                        </th>
                                    </tr>
                                </thead>
                                {currentPageDatatransporte && currentPageDatatransporte?.length !== 0 ? (
                                    <tbody>
                                        {currentPageDatatransporte?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th>{index + 1}</th>
                                                    <td>{item?.Persona?.cedula}</td>
                                                    <td>{item?.Persona?.nombre}</td>
                                                    <td>{item?.Persona?.apellido}</td>
                                                    <td>{item?.Persona?.celular}</td>
                                                    <td>
                                                        <button
                                                            onClick={() => handleShowEditar(item)}
                                                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                                                        >
                                                            {' '}
                                                            <Icon icon="raphael:edit" />
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            onClick={() => {
                                                                handleShowEliminar(item);
                                                            }}
                                                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                                                        >
                                                            {' '}
                                                            <Icon icon="majesticons:delete-bin" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            {' '}
                                            <td colSpan={12} className="text-center">
                                                SIN TRANSPORTE
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>

                    </section>

                    {pageCount > 1 && (
                        <PaginadorComponent
                            setCurrentPage={setCurrentPage}
                            pages={pageCount}
                            styleGroup="d-flex justify-content-center pt-4"
                        />
                    )}

                    <div className='d-flex justify-content-end'>
                        <Link
                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-dark`}
                            to={'/configuracion'}
                        >
                            {' '}
                            <Icon icon="icon-park-solid:back" />
                        </Link>
                    </div>
                </div>
            )}


            {/** modal eliminar un cliente**/}
            <section>
                <ModalGeneralComponent
                    styleGroup="d-flex align-items-center modal-general "
                    styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
                    show={showEliminar}
                    handleClose={handleCloseEliminar}
                >
                    <form action="">
                        <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar a ${currentPersona?.Persona?.nombre} ${currentPersona?.Persona?.apellido} ?`}</TitleH2Component>

                        <div className="d-flex justify-content-end">
                            <button type="button" onClick={handleCloseEliminar} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
                                Cancelar
                            </button>
                            <button type="button" className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`} onClick={eliminarTransporte}>
                                Si
                            </button>
                        </div>
                    </form>
                </ModalGeneralComponent>
            </section>

            <section>
                <ModalGeneralComponent
                    ModalHeader
                    titulo={`${showEdit ? "EDITAR" : "REGISTRAR"} TRANSPORTE`}
                    styleGroup="d-flex align-items-center modal-general "
                    styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
                    show={show}
                    handleClose={handleClose}
                    handleShow={handleShow}
                >
                    <div className="container">
                        <form action="" onSubmit={showEdit ? editarTransporte : crearTransporte}>
                            {!alert && (
                                <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                                    {mensaje}
                                </ParrafoComponent>
                            )}

                            <div className="row g-4">
                                <div className="col-12 col-sm-6">
                                    <input
                                        type="text"
                                        htmlFor="cudula"
                                        className="form-control fw600 WorkSans"
                                        placeholder="Ingrese la cc"
                                        name="cedula"
                                        value={formDataPersona.cedula}
                                        onChange={handleInputChangePersona}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>

                               {!showEdit && <div className="col-12 col-sm-6">
                                    <button
                                        type="button"
                                        className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
                                        onClick={consultarCedula}
                                    >
                                        Verificar cc
                                    </button>
                                </div>}
                                <div className="col-12">
                                    <InputComponent
                                        placeholder="Nombres"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="text"
                                        value={formDataPersona.nombre}
                                        name="nombre"
                                        onChange={handleInputChangePersona}
                                    />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <InputComponent
                                        placeholder="Apellidos"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="text"
                                        value={formDataPersona.apellido}
                                        name="apellido"
                                        onChange={handleInputChangePersona}
                                    />
                                </div>

                                <div className="col-12 col-sm-6">
                                    <InputComponent
                                        placeholder="Celular"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="number"
                                        value={formDataPersona.celular}
                                        name="celular"
                                        onChange={handleInputChangePersona}
                                    />
                                </div>

                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                <button
                                    type="button"
                                    onClick={handleClose}
                                    className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                                >
                                    Cancelar
                                </button>
                                {
                                    <button
                                        type="submit"
                                        className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                                        disabled={isverificado ? false : true}
                                    >
                                        {showEdit ? "Editar" : "Agregar"}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </ModalGeneralComponent>
            </section>
        </Fragment>
    )
}
export default TransportePage;